import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { CaseIncidentTableEntry } from '../../../../types';

type CellParams = ICellRendererParams<CaseIncidentTableEntry> & { findingsCallback: (findings: CaseIncidentTableEntry) => void };

@Component({
  selector: 'app-pan-cell-case-tracking-guest-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-case-tracking-guest-actions.component.html',
  styleUrl: './cell-case-tracking-guest-actions.component.scss',
})
export class CellCaseTrackingGuestActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
